<template>
  <div id="software">
    <b-container style="margin-top: 100px; margin-bottom: 100px;">
      <b-row>
        <!-- <b-col lg="3" md="4" style="text-align: center;">
          Professional Experience
        </b-col> -->
        <!-- Software + Skills-->
        <b-col lg="12" md="12" style="padding-top: 100px;">
            
            <div style="margin-bottom: 50px;" v-scroll-reveal="{ delay: 100 }">
              <h2 class="section-title">Software and Skills</h2>
              <!-- <p class="text-gray">Firms I've worked with, etc. etc.</p> -->
            </div>
            <div>

              <div v-scroll-reveal="{ delay: 100 }">
                <b-row>
                  <b-col lg="3" md="4">
                    <h5>Jack Bernstein, Injury Attorneys</h5>
                    <span class="text-gray">
                      April 2023 - Present
                      <br/>
                      <span>Full-time</span>
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <p>
                      I learned quite a lot at the law office of Ms. Schlitzkus. Everything from ... to. blahblah blah blah blahblah blah blah
                    </p>
                    <ul style="padding-left: 40px;">
                      <li>Attended all court hearings related to my case assignments.</li>
                      <li>Used OPTIMA to record notes from visitations as well as document plans, findings, results, and requests</li>
                    </ul>
                  </b-col>
                </b-row>
              </div>


              <div v-scroll-reveal="{ delay: 150 }" style="padding-top: 50px;">
                <b-row>
                  <b-col lg="3" md="4">
                    <h5>Schlitzkus Law</h5>
                    <span class="text-gray">
                      Oct 2022 - Jan 2023
                      <br/>
                      <span>Full-time</span>
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <p>
                      I learned quite a lot at the law office of Ms. Schlitzkus. Everything from ... to. blahblah blah blah blahblah blah blah
                    </p>
                    <ul style="padding-left: 40px;">
                      <li>Attended all court hearings related to my case assignments.</li>
                      <li>Used OPTIMA to record notes from visitations as well as document plans, findings, results, and requests</li>
                    </ul>
                  </b-col>
                </b-row>
              </div>

              <div v-scroll-reveal="{ delay: 200 }" style="padding-top: 50px;">
                <b-row>
                  <b-col lg="3" md="4">
                    <h5>Volunteer Child Advocate</h5>
                    <span class="text-gray">
                      Jan 2022 - Present
                      <br/>
                      Part-time
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <p>
                      Attended all court hearings related to my case assignments.
                    </p>
                    <ul style="padding-left: 40px;">
                      <li>Directed clients in identifying and obtaining available benefits and community and social services.</li>
                      <li>Embraced the role as an advocate by offering continued displays of validation, reinforcement, and mindfulness towards the children I was assigned to.</li>
                    </ul>
                  </b-col>
                </b-row>
              </div>


            </div>
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
import {BRow, BCol, BContainer, BCard, } from 'bootstrap-vue'
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="css">


</style>
